import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Crown } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button, KenteStripe } from "../components/Primitives";

const HERO = "https://images.unsplash.com/photo-1760727752323-7023aca96d34?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function Login() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  return (
    <div className="grid min-h-screen lg:grid-cols-2" data-testid="login-page">
      <div className="relative hidden lg:block">
        <img src={HERO} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-ink/30" />
        <div className="absolute bottom-0 p-12">
          <h2 className="font-serif text-4xl font-semibold leading-tight text-bone">
            "Until the lion learns to write, every story will glorify the hunter."
          </h2>
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-gold">African Proverb</p>
        </div>
      </div>

      <div className="flex flex-col">
        <KenteStripe />
        <div className="flex flex-1 items-center justify-center px-8">
          <div className="w-full max-w-sm text-center">
            <div className="mx-auto flex h-14 w-14 items-center justify-center border border-gold/40 text-gold">
              <Crown className="h-7 w-7" />
            </div>
            <h1 className="mt-6 font-serif text-4xl font-semibold text-bone">Enter the Archive</h1>
            <p className="mt-3 text-muted">
              Sign in to save bookmarks, track learners, and ask the AI history tutor.
            </p>
            <Button variant="gold" onClick={login} className="mt-8 w-full" data-testid="google-login-btn">
              Continue with Google
            </Button>
            <button onClick={() => navigate("/")} className="mt-6 text-sm text-muted hover:text-gold" data-testid="back-home-btn">
              ← Back to home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
